import React, { useState } from 'react';
import cn from 'classnames';

import MelodyModal from 'components/common/MelodyModal';

import css from 'styles/components/common/quickshop.scss';

interface QuickShopProps {
  isButton?: boolean;
  isSponsored?: boolean;
  isStyleRoom?: boolean;
  onClick?: () => void;
}

export const QuickShop = ({ onClick, isButton = false }: QuickShopProps) => {
  const [quickShopVisible, setQuickShopVisible] = useState(false);

  const quickShopClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setQuickShopVisible(true);
    if (onClick) {
      onClick();
    }
  };

  return (
    <>
    <button type="button" className={cn(css.quickShop, { [css.button]: isButton })} onClick={quickShopClicked}>Quick Shop</button>
        <MelodyModal
          onRequestClose={() => setQuickShopVisible(false)}
          isOpen={quickShopVisible}
          headingTestId="quickShopHeader"
          buttonTestId="quickShopClose"
        >Quick Shop Modal</MelodyModal>
    </>
  );
};

export default QuickShop;
